import { Outlet } from "react-router-dom";
import Footer from "./Partials/Footer";
import Header from "./Partials/Header";

function Layout(){
    return(
        <>
            <Header />
            <div className="container">
                <Outlet />
            </div>
            <Footer/>
        </>
    )
}
export default Layout;